import Trajectory from '@/models/Trajectory';

const GET_TRAJECTORIES = 'get_trajectories';
const GET_TRAJECTORIES_REQUEST = 'get_trajectories_request';
const GET_TRAJECTORIES_SUCCESS = 'get_trajectories_success';
const GET_TRAJECTORIES_ERROR = 'get_trajectories_error';

export { GET_TRAJECTORIES };

export default {
    state: {
        trajectories: [],
        loading: false,
        trajectoriesErrors: [],
        trajectoriesMeta: {},
    },
    mutations: {
        [GET_TRAJECTORIES_REQUEST]: (state) => {
            state.trajectories = [];
            state.loading = true;
            state.trajectoriesErrors = [];
            // state.trajectoriesMeta = {};
        },
        [GET_TRAJECTORIES_SUCCESS]: (state, { trajectories, meta }) => {
            state.trajectories = trajectories;
            state.loading = false;
            state.trajectoriesErrors = [];
            state.trajectoriesMeta = meta;
        },
        [GET_TRAJECTORIES_ERROR]: (state, { errors }) => {
            state.trajectories = [];
            state.loading = false;
            state.trajectoriesErrors = errors;
            state.trajectoriesMeta = {};
        },
    },
    actions: {
        [GET_TRAJECTORIES]: ({ commit, state }, { params = {} }) => {
            commit(GET_TRAJECTORIES_REQUEST);
            return new Promise((resolve, reject) => {
                // If no page specified at dispatch
                if (!params.page) {
                    // Use the current one if present, the first one othewise
                    if (state.trajectoriesMeta.current_page) {
                        params.page = state.trajectoriesMeta.current_page;
                    } else {
                        params.page = 1;
                    }
                }

                Trajectory.collection(params)
                    .then(({items, meta}) => {
                        const trajectories = items;
                        commit(GET_TRAJECTORIES_SUCCESS, { trajectories, meta });
                        resolve(items);
                    })
                    .catch(({ status, errors }) => {
                        commit(GET_TRAJECTORIES_ERROR, { errors });
                        reject({ status, errors });
                    });
            });
        },
    },
    getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/trajectories.js